<template>
  <div v-if="loading" class="my-6" key="1">
    <Spinner />
  </div>
  <div id="app checkout" class="pb-4" v-else-if="checkoutType === 'single'" key="2">
    <div class="container my-5">
      <div class="row">
        <div class="col-lg-6">
          <div class="mx-auto" style="max-width: 400px">
            <Summary></Summary>
          </div>
        </div>
        <div class="col-lg-6 mb-5">
          <div class="mx-auto" style="max-width: 400px">
            <RegisterLogin></RegisterLogin>
            <Invoice v-if="defaultCheckout"></Invoice>
            <PaymentButton></PaymentButton>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else-if="checkoutType === 'membership'" id="app checkout" class="pb-4" key="3">
    <div class="container my-5">
      <div class="row">
        <div class="col-lg-6">
          <div class="mx-auto" style="max-width: 400px">
            <PlanSummary></PlanSummary>
          </div>
        </div>
        <div class="col-lg-6 mb-0 mb-lg-5">
          <div class="mx-auto" style="max-width: 400px">
            <RegisterLogin></RegisterLogin>
            <CardForm v-if="showTpayCardForm"></CardForm>
            <PayuCardForm v-if="showPayuCardForm"></PayuCardForm>
            <Invoice v-if="defaultCheckout"></Invoice>
            <PaymentButton></PaymentButton>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// single
import Summary from './components/single/Summary'

// membership
import CardForm from './components/membership/CardForm'
import PayuCardForm from './components/membership/PayuCardForm'
import PlanSummary from './components/membership/PlanSummary'

//universal
import Invoice from './components/Invoice'

import RegisterLogin from './components/RegisterLogin'
import PaymentButton from './components/PaymentButton'
import Spinner from '~/app2/components/Spinner'
import _ from 'lodash'

export default {
  components: {
    CardForm,
    PayuCardForm,
    PlanSummary,
    Summary,
    RegisterLogin,
    Invoice,
    PaymentButton,
    Spinner,
  },
  computed: {
    loading() {
      return this.$store.state.loading
    },
    page() {
      return this.$store.state.page
    },
    course() {
      return this.$store.state.course
    },
    showTpayCardForm() {
      return _.get(this, 'page.payment_provider') === 'Tpay'
    },
    showPayuCardForm() {
      return _.get(this, 'page.payment_provider') === 'PayU'
    },
    defaultCheckout() {
      if (_.get(this.page, 'options.simplified_checkout_page')) {
        return false
      }

      if (
        _.get(this.course, 'is_free') &&
        !_.get(this.course, 'student_suggested_price') &&
        !this.selectedOrderBumpsCount
      ) {
        return false
      }

      return true
    },
    checkoutType() {
      return this.$store.state.checkoutType
    },
    selectedOrderBumpsCount() {
      return this.$store.state.selectedOrderBumps.length
    },
  },
  methods: {
    setPlan() {
      if (this.checkoutType !== 'membership') {
        return null
      }
      const url_string = window.location.href
      const url = new URL(url_string)
      let plan = url.searchParams.get('plan')
      if (!_.includes(this.plans, plan)) {
        plan = this.plans[0]
      }
      this.$store.commit('setCurrentPlan', plan)
    },
    setQuantity() {
      const url_string = window.location.href
      const url = new URL(url_string)
      let q = parseInt(url.searchParams.get('q'))
      if (!q || isNaN(q) || q < 1) {
        q = 1
      }
      this.$store.commit('updateQuantity', q)
    },
  },
  mounted() {
    this.$store
      .dispatch('getCheckoutData')
      // .then(this.setPlan)
      .then(this.setQuantity)
  },
}
</script>
